import { TslDebug } from '@/components/TslDebug';
import TslDebugArea from '@/components/TslDebugArea';
import WebGpuCanvas from '@/components/WebGpuCanvas';
import { OrbitControls, PerspectiveCamera } from '@react-three/drei';
import * as React from 'react';
import { positionLocal } from 'three/tsl';

export type Props = {};

function App01(props: Props) {
  const {} = props;
  const fragmentNode = React.useMemo(() => {
    const p = positionLocal;
    const radius = 0.5;
    const circle = p.x
      .mul(p.x)
      .add(p.y.mul(p.y))
      .sub(radius * radius)
      .abs()
      .step(0.01);
    const line = circle;
    return line;
  }, []);
  return (
    <TslDebugArea style={{ backgroundColor: 'black' }}>
      {(el) => (
        <WebGpuCanvas>
          <PerspectiveCamera
            makeDefault
            fov={53}
            aspect={el.clientWidth / el.clientHeight}
            near={0.1}
            far={10}
            position={[0, 0, 1]}
          />
          <mesh name="node-mesh">
            <planeGeometry args={[5, 5]} />
            <nodeMaterial fragmentNode={fragmentNode} />
            <TslDebug meshName={'node-mesh'} />
          </mesh>
          <gridHelper rotation={[-Math.PI / 2, 0, 0]} />
          <axesHelper />
          <OrbitControls />
        </WebGpuCanvas>
      )}
    </TslDebugArea>
  );
}

export default React.memo(App01);
